import { IRootStore } from '../store/rootStore';

export const getPriceWithCurrency = (
  rootStore: IRootStore,
  { value, fractionDigits = 0 }: { value: number; fractionDigits?: number }
) => {
  return `${value.toLocaleString(rootStore.translationsStore.lng, {
    maximumFractionDigits: fractionDigits
  })} ${rootStore.paymentStore.currency}`;
};
